// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_fontawesome.js'
// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import singleProduct from './routes/singleProduct';

// Import everything from checkout
import './checkout/_checkout.js'

// Import everything from ccommon
import './common/_scroll.js'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Product page
  singleProduct,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js